/**
 * SchemeSync HS - API Utility
 * Wraps fetch() to automatically attach JWT auth headers
 */

const API = process.env.REACT_APP_API_URL || 'https://hs.aida-advisory.com';

export function authFetch(url, options = {}) {
  const token = localStorage.getItem('token');
  const headers = { ...(options.headers || {}) };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Don't set Content-Type for FormData (browser sets it with boundary)
  if (options.body && !(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  return fetch(url, { ...options, headers });
}

export { API };
export default API;
